import React, { useEffect, useState } from "react";
import client from "../../../utils/prismicHelpers";
import * as queries from "../../../utils/prismicQueries";
import FullMenu from "../../../main/components/fullmenu";
import Header from "../../../main/components/header";
import "./reimaginJourney.css";
import { useNavigate } from "react-router";
import Footer from "../../footer/Footer/Footer";
import SocialLinks from "../../../main/components/socialLinks";

import ProfileCrd from "../ProfileCrd/ProfileCrd";
import { Helmet } from "react-helmet";
import HealthTopCrd from "../../health/HealthTopCrd/HealthTopCrd";
const ReimaginJourney = () => {
  const navigate = useNavigate();
  const [healthInfo, setHealthDoc] = useState(null);
  useEffect(() => {
    client
      .query({
        query: queries.reimaginJourney,
      })
      .then((response) => {
        const healthInfo = response.data.allReimagin_journeys.edges[0].node;
        setHealthDoc(healthInfo);
      })
      .catch((error) => {
        console.error(error);
      });
  });

  return (
    <>

      <section className=" pb-0 health-pattern  section-common-info ">
        <div className="container">
          <div className="  d-flex flex-column-reverse  flex-md-row  pb-2 justify-content-between">
            <div className="w-75 health-header">
              <h3 className="subtitle  pt-0 ">{healthInfo?.title}</h3>

              <div className="w-75">
                {healthInfo?.desc_list?.map((list, index) => (
                  <p key={index + 1}>
                    {index === 1 ? (
                      <>
                        <span className="fw-bold">
                          {list?.text.slice(0, 27)}
                        </span>
                        <span> {list?.text.slice(27, 2000)}</span>
                      </>
                    ) : (
                      <span>{list?.text}</span>
                    )}
                  </p>
                ))}
              </div>
              <div
                className="thumbnail-box"
                onClick={() => navigate("/reimagine-health/2030_rural_india")}
              >
                <img
                  className=""
                  src={healthInfo?.link1_img?.url}
                  alt="thumbnail"
                ></img>
                <p className="fw-bold text-primary pinter-cursor text-decoration-underline">
                  {healthInfo?.read_more_text}
                </p>
              </div>
              <div
                className="thumbnail-box"
                onClick={() =>
                  navigate("/reimagine-health/2030_frontline_health")
                }
              >
                <img src={healthInfo?.link2_img?.url} alt="thumbnail"></img>
                <p className="fw-bold text-primary pinter-cursor text-decoration-underline">
                  {healthInfo?.link2}
                </p>
              </div>

              <div className="w-75">
                <p>
                  <a href={"mailto:" + healthInfo?.contact_text4}>
                    <span className="pe-1">{healthInfo?.contact_text1}</span>
                  </a>
                  {healthInfo?.contact_text2.slice(0, 87)}
                  <span className="fw-bold">
                    {healthInfo?.contact_text2.slice(87, 91)}
                  </span>
                  {healthInfo?.contact_text2.slice(91, 200)}
                </p>
              </div>
            </div>

            <HealthTopCrd />
          </div>

          <div className="row pb-4">
            {healthInfo?.profile_info?.map((healthInfo, index) => (
              <ProfileCrd profileInfo={healthInfo} key={index + 1}></ProfileCrd>
            ))}
          </div>
        </div>
      </section>
      {/* <div className="health-footer    ">
        <Footer>
          <p className="footer-text p-0 m-0  pe-2 ">{healthInfo?.share_text}</p>
          <SocialLinks showWhatsApp={true} />
        </Footer>
      </div> */}

    </>
  );
};

export default ReimaginJourney;
